import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function UrgencyBar() {
  // Start with 30 minutes (1800 seconds)
  const [timeLeft, setTimeLeft] = useState(1800);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <motion.div initial={{
    y: -50
  }} animate={{
    y: 0
  }} className="fixed top-0 left-0 right-0 z-50 bg-emerald-900 border-b border-emerald-800 px-4 py-2 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm font-medium text-white shadow-lg" data-id="element-222">
      <div className="flex items-center gap-2" data-id="element-223">
        <span className="text-yellow-400" data-id="element-224">⚡</span>
        <span data-id="element-225">Oferta especial termina en:</span>
        <span className="font-mono font-bold text-base bg-emerald-950 px-2 py-0.5 rounded text-emerald-400" data-id="element-226">
          {formatTime(timeLeft)}
        </span>
      </div>
      <a href="#pricing" className="text-xs bg-emerald-600 hover:bg-emerald-500 text-white px-3 py-1 rounded-full font-bold transition-colors whitespace-nowrap" data-id="element-227">
        QUIERO MI PACK →
      </a>
    </motion.div>;
}